module.exports = __webpack_public_path__ + "static/media/business-insights.36f3091d.svg";